module.exports = __webpack_public_path__ + "static/media/actions-bold.ad603a3a.svg";